import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/articles';

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700">
            {t('pillar.eyebrow')}
          </span>
          <h2 className="mt-3 font-display text-2xl font-bold text-stone-900 md:text-3xl">
            {t('pillar.title')}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-stone-500 md:text-base">
            {t('pillar.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {pillarArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-stone-100 bg-white transition-all hover:-translate-y-1 hover:border-stone-200"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="text-xs font-medium uppercase tracking-wide text-stone-400">
                  {article.readingTime}
                </span>
                <h3 className="mt-2 text-base font-semibold leading-snug text-stone-900 transition-colors group-hover:text-emerald-700">
                  {article.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-500">
                  {article.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-700">
                  {t('pillar.readMore')}
                  <span className="flex h-5 w-5 items-center justify-center">
                    <i className="ri-arrow-right-line text-base"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}